import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-3xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-play text-green-500" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-3xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pause text-yellow-500" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-3xl" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-repeat text-blue-500" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]

import { computed, ComputedRef, Ref } from "vue";
import Timer from "@/Interfaces/Timer";
import { useGameStore } from "@/Store/useGameStore";
import { Action } from "@/Interfaces/Action";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimerMenu',
  setup(__props) {

/* Inspiré de : https://play.vuejs.org/#eNp9UstOwzAQ/BXjCyDRBKniUtKKh3qAAyDo0ZfgblO3jm3Zm7RV1X9nHUelSKineGdnxrMb7/mjc1nbAB/xIkivHLIA2LiJMKp21iPbMw8LdmALb2t2SdRLYYSR1gSiLu2GjSPhCn0D18IUeXIhPRUItdMlAlWMFd8NojXsQWol12PBe/VF/Ao+mdmq0lDkiZYkM1+aoFD1NSGOtQO16NWkWoLWtshjYOrmfwRFfhKAyoA7HY9ZOwCD4AelRNXCTYdoKFvoEbaPbnj0GjHrSqlwx26zu8CgDHAvzCGaHr3ifk6d0CaXXjlit0lCG+pi8BuOgda4UFW2CtbQH+j4gktbO6XBv7t4dxB8lJxir6RpN68dFjdOFyZcLkGu/8FXYRsxwT88BPAtCH7sYekrwNSefr3Bls7HZm3njSb2meYnBKubmDHRnhozp9gnvC7tS/eOlKlmYbpFoJX2Q8WgkXno+ILT23o+M/pv3GE27HS0T374AbBs70k= */
const gameStore = useGameStore();

const indexAction: ComputedRef<number> = computed(() => {
  return gameStore.indexAction;
});

const gameActions: ComputedRef<Action[]> = computed(() => {
  return gameStore.gameActions;
});

const timer: Ref<Timer | undefined> = computed(() => {
  return gameStore.timers.find(
    (timer) => timer.action_id === gameStore.indexAction
  );
});

return (_ctx: any,_cache: any) => {
  return (timer.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!timer.value.started && timer.value.time_left > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "mx-auto w-16 h-16 rounded-full flex justify-center items-center cursor-pointer transition-transform duration-1000 ease-in-out transform bg-gradient-to-b from-gray-900 to-gray-800",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(gameStore).startTimer(gameActions.value[indexAction.value]?.timer_id ?? 0)))
            }, _hoisted_3))
          : _createCommentVNode("", true),
        (timer.value.started)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "mx-auto w-16 h-16 rounded-full flex justify-center items-center cursor-pointer transition-transform duration-1000 ease-in-out transform bg-gradient-to-b from-gray-900 to-gray-800",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(gameStore).pauseTimer(gameActions.value[indexAction.value]?.timer_id ?? 0)))
            }, _hoisted_5))
          : _createCommentVNode("", true),
        (
        timer.value.started ||
        timer.value.time_full === 0 ||
        (!timer.value.started && timer.value.time_left !== timer.value.time_full)
      )
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "mx-auto w-16 h-16 rounded-full flex justify-center items-center cursor-pointer transition-transform duration-1000 ease-in-out transform bg-gradient-to-b from-gray-900 to-gray-800",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(gameStore).restartTimer(gameActions.value[indexAction.value]?.timer_id ?? 0)))
            }, _hoisted_7))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})